import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IPL_TEAMS } from '../utils/teams';

// ── Real IPL 2026 Squads ──────────────────────────────────────────────────────
const SQUADS = {
  CSK: {
    captain: 'Ruturaj Gaikwad',
    coach: 'Stephen Fleming',
    players: [
      { name: 'Ruturaj Gaikwad',      role: 'Batter',        type: 'BAT',  isCaptain: true },
      { name: 'MS Dhoni',             role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Sanju Samson',         role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Urvil Patel',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Kartik Sharma',        role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Dewald Brevis',        role: 'Batter',        type: 'BAT' },
      { name: 'Ayush Mhatre',         role: 'Batter',        type: 'BAT' },
      { name: 'Sarfaraz Khan',        role: 'Batter',        type: 'BAT' },
      { name: 'Shivam Dube',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Anshul Kamboj',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Jamie Overton',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Matthew Short',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Prashant Veer',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Zak Foulkes',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Aman Khan',            role: 'All-rounder',   type: 'ALL' },
      { name: 'Ramakrishna Ghosh',    role: 'All-rounder',   type: 'ALL' },
      { name: 'Khaleel Ahmed',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Noor Ahmad',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Nathan Ellis',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Matt Henry',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Rahul Chahar',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Akeal Hosein',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Mukesh Choudhary',     role: 'Bowler',        type: 'BOWL'},
      { name: 'Shreyas Gopal',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Gurjapneet Singh',     role: 'Bowler',        type: 'BOWL'},
    ],
  },
  MI: {
    captain: 'Hardik Pandya',
    coach: 'Mahela Jayawardene',
    players: [
      { name: 'Hardik Pandya',        role: 'All-rounder',   type: 'ALL',  isCaptain: true },
      { name: 'Rohit Sharma',         role: 'Batter',        type: 'BAT' },
      { name: 'Suryakumar Yadav',     role: 'Batter',        type: 'BAT' },
      { name: 'Tilak Varma',          role: 'Batter',        type: 'BAT' },
      { name: 'Sherfane Rutherford',  role: 'Batter',        type: 'BAT' },
      { name: 'Danish Malewar',       role: 'Batter',        type: 'BAT' },
      { name: 'Quinton de Kock',      role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Robin Minz',           role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Ryan Rickelton',       role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Will Jacks',           role: 'All-rounder',   type: 'ALL' },
      { name: 'Naman Dhir',           role: 'All-rounder',   type: 'ALL' },
      { name: 'Mitchell Santner',     role: 'All-rounder',   type: 'ALL' },
      { name: 'Corbin Bosch',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Shardul Thakur',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Atharva Ankolekar',    role: 'All-rounder',   type: 'ALL' },
      { name: 'Raj Angad Bawa',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Mayank Rawat',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Jasprit Bumrah',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Trent Boult',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Deepak Chahar',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Mayank Markande',      role: 'Bowler',        type: 'BOWL'},
      { name: 'Ashwani Kumar',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Mohammad Izhar',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Raghu Sharma',         role: 'Bowler',        type: 'BOWL'},
    ],
  },
  RCB: {
    captain: 'Rajat Patidar',
    coach: 'Andy Flower',
    players: [
      { name: 'Rajat Patidar',        role: 'Batter',        type: 'BAT',  isCaptain: true },
      { name: 'Virat Kohli',          role: 'Batter',        type: 'BAT' },
      { name: 'Devdutt Padikkal',     role: 'Batter',        type: 'BAT' },
      { name: 'Phil Salt',            role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Jitesh Sharma',        role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Jordan Cox',           role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Venkatesh Iyer',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Krunal Pandya',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Tim David',            role: 'All-rounder',   type: 'ALL' },
      { name: 'Jacob Bethell',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Romario Shepherd',     role: 'All-rounder',   type: 'ALL' },
      { name: 'Vicky Ostwal',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Mangesh Yadav',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Satvik Deswal',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Vihaan Malhotra',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Kanishk Chouhan',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Josh Hazlewood',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Bhuvneshwar Kumar',    role: 'Bowler',        type: 'BOWL'},
      { name: 'Yash Dayal',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Rasikh Dar',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Nuwan Thushara',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Suyash Sharma',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Jacob Duffy',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Abhinandan Singh',     role: 'Bowler',        type: 'BOWL'},
    ],
  },
  KKR: {
    captain: 'Ajinkya Rahane',
    coach: 'Abhishek Nayar',
    players: [
      { name: 'Ajinkya Rahane',       role: 'Batter',        type: 'BAT',  isCaptain: true },
      { name: 'Cameron Green',        role: 'Batter',        type: 'BAT' },
      { name: 'Rinku Singh',          role: 'Batter',        type: 'BAT' },
      { name: 'Angkrish Raghuvanshi', role: 'Batter',        type: 'BAT' },
      { name: 'Manish Pandey',        role: 'Batter',        type: 'BAT' },
      { name: 'Rahul Tripathi',       role: 'Batter',        type: 'BAT' },
      { name: 'Rovman Powell',        role: 'Batter',        type: 'BAT' },
      { name: 'Finn Allen',           role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Tim Seifert',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Tejasvi Singh',        role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Rachin Ravindra',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Ramandeep Singh',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Anukul Roy',           role: 'All-rounder',   type: 'ALL' },
      { name: 'Sarthak Ranjan',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Daksh Kamra',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Sunil Narine',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Varun Chakravarthy',   role: 'Bowler',        type: 'BOWL'},
      { name: 'Matheesha Pathirana',  role: 'Bowler',        type: 'BOWL'},
      { name: 'Harshit Rana',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Akash Deep',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Vaibhav Arora',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Kartik Tyagi',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Umran Malik',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Prashant Solanki',     role: 'Bowler',        type: 'BOWL'},
    ],
  },
  SRH: {
    captain: 'Pat Cummins',
    coach: 'Daniel Vettori',
    players: [
      { name: 'Pat Cummins',          role: 'Bowler',        type: 'BOWL', isCaptain: true },
      { name: 'Travis Head',          role: 'Batter',        type: 'BAT' },
      { name: 'Aniket Verma',         role: 'Batter',        type: 'BAT' },
      { name: 'Smaran Ravichandran',  role: 'Batter',        type: 'BAT' },
      { name: 'Heinrich Klaasen',     role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Ishan Kishan',         role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Salil Arora',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Abhishek Sharma',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Nitish Kumar Reddy',   role: 'All-rounder',   type: 'ALL' },
      { name: 'Harshal Patel',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Liam Livingstone',     role: 'All-rounder',   type: 'ALL' },
      { name: 'Kamindu Mendis',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Brydon Carse',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Jack Edwards',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Harsh Dubey',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Shivang Kumar',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Shivam Mavi',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Zeeshan Ansari',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Jaydev Unadkat',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Eshan Malinga',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Onkar Tarmale',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Amit Kumar',           role: 'Bowler',        type: 'BOWL'},
    ],
  },
  DC: {
    captain: 'Axar Patel',
    coach: 'Hemang Badani',
    players: [
      { name: 'Axar Patel',           role: 'All-rounder',   type: 'ALL',  isCaptain: true },
      { name: 'KL Rahul',             role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Abishek Porel',        role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Tristan Stubbs',       role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Ben Duckett',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Karun Nair',           role: 'Batter',        type: 'BAT' },
      { name: 'David Miller',         role: 'Batter',        type: 'BAT' },
      { name: 'Pathum Nissanka',      role: 'Batter',        type: 'BAT' },
      { name: 'Prithvi Shaw',         role: 'Batter',        type: 'BAT' },
      { name: 'Sahil Parakh',         role: 'Batter',        type: 'BAT' },
      { name: 'Sameer Rizvi',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Ashutosh Sharma',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Nitish Rana',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Vipraj Nigam',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Ajay Mandal',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Tripurana Vijay',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Madhav Tiwari',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Auqib Dar',            role: 'All-rounder',   type: 'ALL' },
      { name: 'Mitchell Starc',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Kuldeep Yadav',        role: 'Bowler',        type: 'BOWL'},
      { name: 'T. Natarajan',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Mukesh Kumar',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Kyle Jamieson',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Lungi Ngidi',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Dushmantha Chameera',  role: 'Bowler',        type: 'BOWL'},
    ],
  },
  LSG: {
    captain: 'Rishabh Pant',
    coach: 'Justin Langer',
    players: [
      { name: 'Rishabh Pant',         role: 'Wicket-keeper', type: 'WK',   isCaptain: true },
      { name: 'Nicholas Pooran',      role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Josh Inglis',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Mukul Choudhary',      role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Aiden Markram',        role: 'Batter',        type: 'BAT' },
      { name: 'Himmat Singh',         role: 'Batter',        type: 'BAT' },
      { name: 'Matthew Breetzke',     role: 'Batter',        type: 'BAT' },
      { name: 'Akshat Raghuwanshi',   role: 'Batter',        type: 'BAT' },
      { name: 'Mitchell Marsh',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Wanindu Hasaranga',    role: 'All-rounder',   type: 'ALL' },
      { name: 'Abdul Samad',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Shahbaz Ahmed',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Ayush Badoni',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Arshin Kulkarni',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Mohammad Shami',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Mayank Yadav',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Anrich Nortje',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Avesh Khan',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Mohsin Khan',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Arjun Tendulkar',      role: 'Bowler',        type: 'BOWL'},
      { name: 'Akash Singh',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Digvesh Singh',        role: 'Bowler',        type: 'BOWL'},
      { name: 'M. Siddharth',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Naman Tiwari',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Prince Yadav',         role: 'Bowler',        type: 'BOWL'},
    ],
  },
  RR: {
    captain: 'Riyan Parag',
    coach: 'Kumar Sangakkara',
    players: [
      { name: 'Riyan Parag',          role: 'All-rounder',   type: 'ALL',  isCaptain: true },
      { name: 'Yashasvi Jaiswal',     role: 'Batter',        type: 'BAT' },
      { name: 'Shimron Hetmyer',      role: 'Batter',        type: 'BAT' },
      { name: 'Shubham Dubey',        role: 'Batter',        type: 'BAT' },
      { name: 'Vaibhav Suryavanshi',  role: 'Batter',        type: 'BAT' },
      { name: 'Ravi Singh',           role: 'Batter',        type: 'BAT' },
      { name: 'Aman Rao Perala',      role: 'Batter',        type: 'BAT' },
      { name: 'Sanju Samson',         role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Dhruv Jurel',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Donovan Ferreira',     role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Lhuan-dre Pretorius',  role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Ravindra Jadeja',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Sam Curran',           role: 'All-rounder',   type: 'ALL' },
      { name: 'Yudhvir Singh Charak', role: 'All-rounder',   type: 'ALL' },
      { name: 'Jofra Archer',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Ravi Bishnoi',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Tushar Deshpande',     role: 'Bowler',        type: 'BOWL'},
      { name: 'Sandeep Sharma',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Kwena Maphaka',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Adam Milne',           role: 'Bowler',        type: 'BOWL'},
      { name: 'Kuldeep Sen',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Nandre Burger',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Sushant Mishra',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Brijesh Sharma',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Vignesh Puthur',       role: 'Bowler',        type: 'BOWL'},
    ],
  },
  GT: {
    captain: 'Shubman Gill',
    coach: 'Ashish Nehra',
    players: [
      { name: 'Shubman Gill',         role: 'Batter',        type: 'BAT',  isCaptain: true },
      { name: 'Sai Sudharsan',        role: 'Batter',        type: 'BAT' },
      { name: 'Glenn Phillips',       role: 'Batter',        type: 'BAT' },
      { name: 'Shahrukh Khan',        role: 'Batter',        type: 'BAT' },
      { name: 'Jos Buttler',          role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Kumar Kushagra',       role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Anuj Rawat',           role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Tom Banton',           role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Rashid Khan',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Washington Sundar',    role: 'All-rounder',   type: 'ALL' },
      { name: 'Jason Holder',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Jayant Yadav',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Nishant Sindhu',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Sai Kishore',          role: 'All-rounder',   type: 'ALL' },
      { name: 'Mohd. Arshad Khan',    role: 'All-rounder',   type: 'ALL' },
      { name: 'Kagiso Rabada',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Mohammed Siraj',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Prasidh Krishna',      role: 'Bowler',        type: 'BOWL'},
      { name: 'Rahul Tewatia',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Gurnoor Singh Brar',   role: 'Bowler',        type: 'BOWL'},
      { name: 'Manav Suthar',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Luke Wood',            role: 'Bowler',        type: 'BOWL'},
      { name: 'Ishant Sharma',        role: 'Bowler',        type: 'BOWL'},
      { name: 'Ashok Sharma',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Prithvi Raj Yarra',    role: 'Bowler',        type: 'BOWL'},
    ],
  },
  PBKS: {
    captain: 'Shreyas Iyer',
    coach: 'Ricky Ponting',
    players: [
      { name: 'Shreyas Iyer',         role: 'Batter',        type: 'BAT',  isCaptain: true },
      { name: 'Nehal Wadhera',        role: 'Batter',        type: 'BAT' },
      { name: 'Harnoor Pannu',        role: 'Batter',        type: 'BAT' },
      { name: 'Pyla Avinash',         role: 'Batter',        type: 'BAT' },
      { name: 'Shashank Singh',       role: 'Batter',        type: 'BAT' },
      { name: 'Prabhsimran Singh',    role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Vishnu Vinod',         role: 'Wicket-keeper', type: 'WK'  },
      { name: 'Marcus Stoinis',       role: 'All-rounder',   type: 'ALL' },
      { name: 'Marco Jansen',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Priyansh Arya',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Musheer Khan',         role: 'All-rounder',   type: 'ALL' },
      { name: 'Azmatullah Omarzai',   role: 'All-rounder',   type: 'ALL' },
      { name: 'Mitch Owen',           role: 'All-rounder',   type: 'ALL' },
      { name: 'Cooper Connolly',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Harpreet Brar',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Suryansh Shedge',      role: 'All-rounder',   type: 'ALL' },
      { name: 'Ben Dwarshuis',        role: 'All-rounder',   type: 'ALL' },
      { name: 'Arshdeep Singh',       role: 'Bowler',        type: 'BOWL'},
      { name: 'Yuzvendra Chahal',     role: 'Bowler',        type: 'BOWL'},
      { name: 'Lockie Ferguson',      role: 'Bowler',        type: 'BOWL'},
      { name: 'Vyshak Vijaykumar',    role: 'Bowler',        type: 'BOWL'},
      { name: 'Yash Thakur',          role: 'Bowler',        type: 'BOWL'},
      { name: 'Xavier Bartlett',      role: 'Bowler',        type: 'BOWL'},
      { name: 'Pravin Dubey',         role: 'Bowler',        type: 'BOWL'},
      { name: 'Vishal Nishad',        role: 'Bowler',        type: 'BOWL'},
    ],
  },
};

const TYPE_COLOR = { BAT: '#3B82F6', WK: '#8B5CF6', ALL: '#10B981', BOWL: '#F59E0B' };
const TYPE_ORDER = { WK: 0, BAT: 1, ALL: 2, BOWL: 3 };

export default function TeamPage() {
  const { shortName } = useParams();
  const navigate = useNavigate();
  const key = shortName?.toUpperCase();
  const team = IPL_TEAMS[key];
  const squad = SQUADS[key];
  const [tab, setTab] = useState('squad');
  const [filter, setFilter] = useState('ALL');

  if (!team) {
    return (
      <div style={s.notFound}>
        <div style={{ fontFamily: 'Bebas Neue,sans-serif', fontSize: 96, color: '#EC1C24', lineHeight: 1 }}>404</div>
        <div style={{ color: 'rgba(255,255,255,.4)', fontSize: 15 }}>No team found for "{shortName}"</div>
        <button style={s.nfBtn} onClick={() => navigate('/')}>← Home</button>
      </div>
    );
  }

  const ac = team.color;
  const players = squad?.players || [];
  const filtered = filter === 'ALL' ? players : players.filter(p => p.type === filter);
  const sorted = [...filtered].sort((a, b) => TYPE_ORDER[a.type] - TYPE_ORDER[b.type]);

  const counts = { WK: 0, BAT: 0, ALL: 0, BOWL: 0 };
  players.forEach(p => counts[p.type]++);

  return (
    <div style={s.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Rajdhani:wght@500;600;700&display=swap');
        .tp-back:hover  { color:#fff !important }
        .tp-tab:hover   { color:rgba(255,255,255,.75) !important }
        .tp-card:hover  { border-color:${ac}55 !important; background:${ac}0d !important; transform:translateY(-2px) }
        .tp-filter:hover{ border-color:${ac} !important; color:${ac} !important }
        .tp-player:hover{ background:${ac}12 !important; border-color:${ac}44 !important; transform:translateX(4px) }
        @keyframes fadeUp{ from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
        @keyframes glow  { 0%,100%{box-shadow:0 0 28px ${ac}44} 50%{box-shadow:0 0 60px ${ac}66} }
      `}</style>

      {/* HERO */}
      <div style={s.hero}>
        <div style={{ position:'absolute', inset:0, background:`radial-gradient(ellipse 80% 55% at 50% 0%,${ac}20 0%,transparent 68%)`, pointerEvents:'none' }} />
        <div style={s.heroGrid} />
        <div style={{ position:'relative', zIndex:1, textAlign:'center' }}>
          <button className="tp-back" style={s.back} onClick={() => navigate(-1)}>← Back</button>

          <div style={{ ...s.logoWrap, borderColor: ac, animation:'glow 3s ease-in-out infinite' }}>
            <TeamLogo shortName={team.shortName} size={90} />
          </div>

          <div style={{ fontFamily:'Bebas Neue,sans-serif', fontSize:'clamp(3rem,9vw,6rem)', color:ac, letterSpacing:'.06em', lineHeight:1, textShadow:`0 0 50px ${ac}55`, animation:'fadeUp .4s ease .05s both' }}>
            {team.shortName}
          </div>
          <div style={{ fontFamily:'Rajdhani,sans-serif', fontWeight:600, fontSize:'clamp(.85rem,2vw,1.2rem)', letterSpacing:'.12em', textTransform:'uppercase', color:'rgba(255,255,255,.5)', marginBottom:6, animation:'fadeUp .4s ease .1s both' }}>
            {team.name}
          </div>
          <div style={{ fontFamily:'Rajdhani,sans-serif', fontStyle:'italic', fontSize:16, color:ac, opacity:.8, marginBottom:28, animation:'fadeUp .4s ease .15s both' }}>
            "{team.tagline}"
          </div>

          {/* Stats strip */}
          <div style={{ ...s.strip, animation:'fadeUp .4s ease .2s both' }}>
            {[
              { v: team.titles === 0 ? '—' : `${team.titles}×`, l: 'Titles'  },
              { v: squad?.captain?.split(' ').pop(),              l: 'Captain' },
              { v: squad?.coach?.split(' ').pop(),                l: 'Coach'   },
              { v: players.length,                                l: 'Players' },
            ].map(({ v, l }, i, arr) => (
              <React.Fragment key={l}>
                <div style={{ flex:1, padding:'14px 8px', textAlign:'center' }}>
                  <div style={{ fontFamily:'Bebas Neue,sans-serif', fontSize:24, color:ac, lineHeight:1, marginBottom:3 }}>{v}</div>
                  <div style={{ fontSize:9, color:'rgba(255,255,255,.35)', textTransform:'uppercase', letterSpacing:'.1em' }}>{l}</div>
                </div>
                {i < arr.length - 1 && <div style={{ width:1, background:'rgba(255,255,255,.08)' }} />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* TABS */}
      <div style={s.tabBar}>
        {['squad','overview','info'].map(t => (
          <button key={t} className="tp-tab" onClick={() => setTab(t)} style={{
            ...s.tabBtn,
            color: tab === t ? ac : 'rgba(255,255,255,.38)',
            borderBottom: `2px solid ${tab === t ? ac : 'transparent'}`,
          }}>{t}</button>
        ))}
      </div>

      {/* CONTENT */}
      <div style={s.content}>

        {/* ── SQUAD ── */}
        {tab === 'squad' && (
          <div style={{ animation:'fadeUp .3s ease both' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:20 }}>
              <div style={s.sectionTitle}>Full <span style={{ color:ac }}>Squad 2026</span></div>
              {/* Filter buttons */}
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {[
                  { val:'ALL',  lbl:`All (${players.length})` },
                  { val:'WK',   lbl:`WK (${counts.WK})`       },
                  { val:'BAT',  lbl:`BAT (${counts.BAT})`     },
                  { val:'ALL_R',lbl:`ALL (${counts.ALL})`     },
                  { val:'BOWL', lbl:`BOWL (${counts.BOWL})`   },
                ].map(({ val, lbl }) => {
                  const resolvedVal = val === 'ALL_R' ? 'ALL' : val;
                  const isActive = val === 'ALL' ? filter === 'ALL' : filter === resolvedVal;
                  return (
                    <button key={val} className="tp-filter"
                      onClick={() => setFilter(val === 'ALL' ? 'ALL' : resolvedVal)}
                      style={{ ...s.filterBtn, background: isActive ? ac+'22' : 'transparent', borderColor: isActive ? ac : 'rgba(255,255,255,.15)', color: isActive ? ac : 'rgba(255,255,255,.45)' }}>
                      {lbl}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Composition bar */}
            <div style={{ display:'flex', gap:3, height:6, borderRadius:4, overflow:'hidden', marginBottom:20 }}>
              {(['WK','BAT','ALL','BOWL']).map(t => (
                <div key={t} style={{ flex: counts[t], background: TYPE_COLOR[t] }} title={`${t}: ${counts[t]}`} />
              ))}
            </div>

            <div style={s.playerGrid}>
              {sorted.map((p, i) => (
                <div key={i} className="tp-player" style={{ ...s.playerRow, animationDelay:`${i*.025}s`, animation:'fadeUp .3s ease both' }}>
                  <div style={{ width:34, height:34, borderRadius:'50%', background:TYPE_COLOR[p.type]+'1a', border:`1.5px solid ${TYPE_COLOR[p.type]}55`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <span style={{ fontSize:8, fontWeight:700, color:TYPE_COLOR[p.type], letterSpacing:'.04em' }}>{p.type}</span>
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontFamily:'Rajdhani,sans-serif', fontWeight:700, fontSize:15, color:'#fff', lineHeight:1.2, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.name}</div>
                    <div style={{ fontSize:11, color:'rgba(255,255,255,.38)', marginTop:1 }}>{p.role}</div>
                  </div>
                  {p.isCaptain && (
                    <div style={{ fontSize:9, padding:'3px 9px', borderRadius:20, background:ac+'22', color:ac, fontWeight:700, letterSpacing:'.06em', textTransform:'uppercase', flexShrink:0 }}>Captain</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── OVERVIEW ── */}
        {tab === 'overview' && (
          <div style={{ animation:'fadeUp .3s ease both' }}>
            <div style={s.sectionTitle}>Team <span style={{ color:ac }}>Overview</span></div>

            {/* Squad composition card */}
            <div style={{ background:'rgba(255,255,255,.03)', border:'1px solid rgba(255,255,255,.08)', borderRadius:10, padding:'18px 20px', marginBottom:20 }}>
              <div style={{ fontSize:10, color:'rgba(255,255,255,.4)', textTransform:'uppercase', letterSpacing:'.1em', marginBottom:12 }}>Squad Composition ({players.length} players)</div>
              <div style={{ display:'flex', gap:3, height:10, borderRadius:6, overflow:'hidden', marginBottom:14 }}>
                {(['WK','BAT','ALL','BOWL']).map(t => (
                  <div key={t} style={{ flex:counts[t], background:TYPE_COLOR[t] }} />
                ))}
              </div>
              <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
                {[['WK','Wicket-keepers'],['BAT','Batters'],['ALL','All-rounders'],['BOWL','Bowlers']].map(([t,l]) => (
                  <div key={t} style={{ display:'flex', alignItems:'center', gap:6 }}>
                    <div style={{ width:10, height:10, borderRadius:2, background:TYPE_COLOR[t] }} />
                    <span style={{ fontSize:12, color:'rgba(255,255,255,.6)' }}>{counts[t]} {l}</span>
                  </div>
                ))}
              </div>
            </div>

            <div style={s.grid3}>
              {[
                { l:'Full Name',   v: team.name },
                { l:'Captain',     v: squad?.captain },
                { l:'Coach',       v: squad?.coach },
                { l:'Home Ground', v: team.homeGround },
                { l:'IPL Titles',  v: team.titles === 0 ? 'Yet to win 🏏' : `${team.titles}× Champion 🏆`, hi:true },
                { l:'Battle Cry',  v: `"${team.tagline}"`, hi:true },
              ].map(({ l, v, hi }) => (
                <div key={l} className="tp-card" style={s.card}>
                  <div style={s.cardLabel}>{l}</div>
                  <div style={{ ...s.cardVal, color: hi ? ac : '#fff' }}>{v}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── INFO ── */}
        {tab === 'info' && (
          <div style={{ animation:'fadeUp .3s ease both' }}>
            <div style={s.sectionTitle}>Team <span style={{ color:ac }}>Details</span></div>
            <div style={s.grid3}>
              {[
                { l:'Short Name',     v: team.shortName },
                { l:'Full Name',      v: team.name },
                { l:'Captain 2026',   v: squad?.captain },
                { l:'Coach',          v: squad?.coach },
                { l:'Home Ground',    v: team.homeGround },
                { l:'IPL Titles',     v: team.titles === 0 ? 'None yet' : `${team.titles}`, hi:true },
                { l:'Squad Size',     v: `${players.length} players` },
                { l:'Max Overseas',   v: '8 in squad / 4 in XI' },
                { l:'Battle Cry',     v: `"${team.tagline}"`, hi:true },
              ].map(({ l, v, hi }) => (
                <div key={l} className="tp-card" style={s.card}>
                  <div style={s.cardLabel}>{l}</div>
                  <div style={{ ...s.cardVal, color: hi ? ac : '#fff' }}>{v}</div>
                </div>
              ))}
            </div>
            <div style={{ marginTop:24 }}>
              <div style={s.cardLabel}>Team Colours</div>
              <div style={{ display:'flex', gap:12, marginTop:10, flexWrap:'wrap' }}>
                {[team.color, team.secondaryColor].map((c, i) => (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <div style={{ width:36, height:36, borderRadius:8, background:c, border:'1px solid rgba(255,255,255,.12)' }} />
                    <span style={{ fontSize:12, color:'rgba(255,255,255,.45)', fontFamily:'monospace' }}>{c}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

// ── Styles ────────────────────────────────────────────────────────────────────
const s = {
  page:       { minHeight:'100vh', background:'#09090f', color:'#f0f0f0', fontFamily:"'Inter',sans-serif" },
  notFound:   { minHeight:'100vh', background:'#09090f', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:16 },
  nfBtn:      { marginTop:8, padding:'10px 26px', background:'#ff6b00', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontFamily:'Rajdhani,sans-serif', fontWeight:700, fontSize:14 },
  hero:       { position:'relative', overflow:'hidden', padding:'64px 24px 40px' },
  heroGrid:   { position:'absolute', inset:0, pointerEvents:'none', backgroundImage:'linear-gradient(rgba(255,255,255,.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.02) 1px,transparent 1px)', backgroundSize:'44px 44px' },
  back:       { display:'inline-block', marginBottom:24, background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,.35)', fontFamily:'Rajdhani,sans-serif', fontWeight:700, fontSize:13, letterSpacing:'.08em', textTransform:'uppercase', transition:'color .2s' },
  logoWrap:   { width:124, height:124, borderRadius:'50%', border:'2px solid', margin:'0 auto 18px', display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,.45)' },
  strip:      { display:'flex', alignItems:'stretch', maxWidth:460, margin:'0 auto', border:'1px solid rgba(255,255,255,.08)', borderRadius:12, overflow:'hidden', background:'rgba(255,255,255,.03)' },
  tabBar:     { display:'flex', justifyContent:'center', borderBottom:'1px solid rgba(255,255,255,.08)', gap:4, padding:'0 24px' },
  tabBtn:     { padding:'12px 28px', background:'none', border:'none', borderBottom:'2px solid transparent', cursor:'pointer', marginBottom:-1, fontFamily:'Rajdhani,sans-serif', fontWeight:700, fontSize:14, letterSpacing:'.1em', textTransform:'uppercase', transition:'color .2s,border-color .2s' },
  content:    { maxWidth:780, margin:'0 auto', padding:'36px 24px 80px' },
  sectionTitle:{ fontFamily:'Bebas Neue,sans-serif', fontSize:28, letterSpacing:'.06em', color:'#fff', marginBottom:20 },
  grid3:      { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:12 },
  card:       { background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.08)', borderRadius:10, padding:'16px 18px', transition:'all .2s', cursor:'default' },
  cardLabel:  { fontSize:10, color:'rgba(255,255,255,.32)', textTransform:'uppercase', letterSpacing:'.12em', marginBottom:8 },
  cardVal:    { fontFamily:'Rajdhani,sans-serif', fontWeight:600, fontSize:16, lineHeight:1.3 },
  filterBtn:  { padding:'5px 12px', border:'1px solid', borderRadius:20, cursor:'pointer', fontFamily:'Rajdhani,sans-serif', fontWeight:700, fontSize:12, letterSpacing:'.06em', textTransform:'uppercase', transition:'all .18s' },
  playerGrid: { display:'flex', flexDirection:'column', gap:6 },
  playerRow:  { display:'flex', alignItems:'center', gap:14, padding:'10px 14px', background:'rgba(255,255,255,.03)', border:'1px solid rgba(255,255,255,.07)', borderRadius:8, transition:'all .18s', cursor:'default' },
};